import { RefObject, createContext, useContext, useState, useRef, type Dispatch } from "react";
import { Achievement, AchievementKey } from "../lib/achievements";
import { User } from "../lib/user"
import { grantAndSaveAchievement } from "../lib/stats";

interface Props {
  children: any
  setUser: (user: User) => void
}

const AchievementsContext = createContext({
  achievements: {current: []} as RefObject<Achievement[]>,
  setAchievements: (() => undefined) as Dispatch<any>,
  isAchievementsModalOpen: false,
  setIsAchievementsModalOpen: (() => undefined) as Dispatch<any>,
  grantKeyedAchievement: (user: User, key: AchievementKey) => {}
});

export function AchievementsProvider({ setUser, children }: Props) {
  const achievements = useRef<Achievement[]>([]);
  const setAchievements = (a: Achievement[]) => {
    achievements.current = a
  }
  const [isAchievementsModalOpen, setIsAchievementsModalOpen] = useState(false);

  const grantKeyedAchievement = (user: User, key: AchievementKey) => {
    console.log('current acheivements: ' + user.stats().achievements)
    const {achievement, stats} = grantAndSaveAchievement(user, key)
    if(!achievement) {
      return
    }
    setAchievements([achievement])
    setIsAchievementsModalOpen(true)
    const newUser = user.cloneWithNewStats(stats)
    console.log('updated acheivements: ' + newUser.stats().achievements)
    setUser(newUser)
  }

    return (
      <AchievementsContext.Provider value={{achievements, setAchievements, isAchievementsModalOpen, setIsAchievementsModalOpen, grantKeyedAchievement}}>{children}</AchievementsContext.Provider>
        );
}

export function useAchievements() {
    const context = useContext(AchievementsContext);
    if (!context) {
          throw new Error("use must be used within an AchievementsProvider");
        }
    return context;
}
